/* SmartBliss 2026: interazioni delle sezioni sb-* (colori dell'apertura, Guardalo da vicino, permuta).
   Ogni sezione si inizializza da sola e di nuovo quando l'editor di Shopify la ricarica. */
(function () {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const euro = n => String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' €';

  function initHero(root) {
    const img = root.querySelector('[data-sb-hero-img]'), name = root.querySelector('[data-sb-sw-name]');
    root.querySelectorAll('[data-sb-sw]').forEach(b => b.addEventListener('click', () => {
      root.querySelectorAll('[data-sb-sw]').forEach(x => x.setAttribute('aria-pressed', x === b));
      if (name) name.textContent = b.dataset.name;
      if (!img || !b.dataset.src) return;
      img.classList.add('is-fading');
      setTimeout(() => { img.src = b.dataset.src; img.alt = b.dataset.alt; img.classList.remove('is-fading'); }, reduce ? 0 : 180);
    }));
  }

  function initCloser(root) {
    const data = JSON.parse(root.querySelector('[data-sb-closer-data]').textContent);
    const stage = root.querySelector('[data-sb-closer-stage]');
    if (!data.colors.length || !data.views.length) return;
    let color = 0, view = 0;
    const esc = s => String(s || '').replace(/[&<>"]/g, c => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'}[c]));
    function render() {
      const c = data.colors[color], v = data.views[view];
      if (v.kind === 'misure') {
        stage.innerHTML = `<figure><img src="${esc(c.small)}" alt="${esc(data.smallName + ' ' + c.name)}"><figcaption>${esc(v.caption1)}</figcaption></figure>
          <figure class="is-big"><img src="${esc(c.front)}" alt="${esc(data.bigName + ' ' + c.name)}"><figcaption>${esc(v.caption2)}</figcaption></figure>`;
      } else {
        const src = c[v.kind] || c.front;
        stage.innerHTML = src ? `<img src="${esc(src)}" alt="${esc(data.bigName + ' ' + c.name + ', ' + v.title.toLowerCase())}">` : '';
      }
      root.querySelectorAll('.sb-pill').forEach((p, i) => { p.classList.toggle('is-open', i === view); p.querySelector('.sb-pill__head').setAttribute('aria-expanded', i === view); });
      root.querySelectorAll('[data-sb-col]').forEach(b => b.setAttribute('aria-pressed', +b.dataset.sbCol === color));
    }
    root.addEventListener('click', e => {
      const col = e.target.closest('[data-sb-col]'); if (col) { color = +col.dataset.sbCol; render(); return; }
      const pick = e.target.closest('[data-sb-pick]'); if (pick) { view = +pick.dataset.sbPick; render(); }
    });
    render();
  }

  function initTrade(root) {
    const form = root.querySelector('[data-sb-trade]'); if (!form) return;
    const out = root.querySelector('[data-sb-trade-value]');
    const calc = () => {
      const base = +form.querySelector('select').value, k = +form.querySelector('input[type=radio]:checked').value;
      out.textContent = 'fino a ' + euro(Math.round(base * k / 5) * 5);
    };
    form.addEventListener('change', calc); calc();
  }

  // every section links this file, so it may run more than once: initialise each root a single time
  const once = fn => root => { if (root.dataset.sbReady) return; root.dataset.sbReady = '1'; fn(root); };
  function init(scope) {
    scope.querySelectorAll('[data-sb-hero]').forEach(once(initHero));
    scope.querySelectorAll('[data-sb-closer]').forEach(once(initCloser));
    scope.querySelectorAll('[data-sb-trade-wrap]').forEach(once(initTrade));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document)); else init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
